export interface Category {
  id: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Close-up%20of%20white%20leather%20sneakers%20on%20a%20warm%20terracotta%20ceramic%20tile%20surface%2C%20soft%20side%20lighting%2C%20minimalist%20editorial%20photography%2C%20high%20detail%2C%20clean%20composition%2C%20warm%20earthy%20tones%2C%20no%20background%20clutter&width=800&height=800&seq=achb-cat-shoes-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Beige%20oversized%20hoodie%20draped%20over%20a%20light%20wooden%20chair%20against%20a%20sage%20green%20wall%2C%20natural%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20cozy%20atmosphere%2C%20warm%20neutral%20tones%2C%20no%20text%2C%20minimal%20background&width=800&height=800&seq=achb-cat-hoodies-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20t-shirt%20on%20a%20linen%20rope%20clothesline%20with%20a%20pale%20blush%20pink%20background%2C%20soft%20natural%20light%2C%20fresh%20clean%20aesthetic%2C%20minimalist%20editorial%20photography%2C%20warm%20tones%2C%20no%20text%2C%20simple%20composition&width=800&height=800&seq=achb-cat-tshirts-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20hanging%20on%20a%20brass%20hook%20against%20a%20cream%20stucco%20wall%2C%20warm%20golden%20hour%20light%2C%20casual%20editorial%20photography%2C%20earthy%20tones%2C%20no%20text%2C%20minimal%20background%20details&width=800&height=800&seq=achb-cat-jackets-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Relaxed%20beige%20linen%20trousers%20folded%20on%20a%20raw%20marble%20slab%20surface%2C%20neutral%20tones%2C%20soft%20diffused%20overhead%20light%2C%20minimalist%20editorial%20photography%2C%20warm%20earthy%20aesthetic%2C%20clean%20composition&width=800&height=800&seq=achb-cat-pants-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Neutral%20canvas%20baseball%20cap%20resting%20on%20a%20stack%20of%20vintage%20leather-bound%20books%20with%20warm%20amber%20tones%2C%20soft%20shadows%2C%20intimate%20product%20photography%2C%20cozy%20library%20feel%2C%20no%20text%2C%20minimal%20background&width=800&height=800&seq=achb-cat-headwear-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Matching%20grey%20tracksuit%20laid%20neatly%20on%20a%20tufted%20velvet%20cushion%20in%20warm%20sand%20tones%2C%20soft%20ambient%20light%2C%20refined%20lifestyle%20product%20photography%2C%20neutral%20palette%2C%20no%20text%2C%20elegant%20minimal%20composition&width=800&height=800&seq=achb-cat-sets-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20cotton%20basics%20in%20white%20and%20blush%20tones%20arranged%20on%20a%20brushed%20brass%20tray%2C%20delicate%20fresh%20aesthetic%2C%20clean%20minimal%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%2C%20elegant%20simple%20composition&width=800&height=800&seq=achb-cat-underwear-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Bold%20red%20soccer%20jersey%20folded%20neatly%20on%20a%20dark%20oak%20wooden%20surface%20with%20dramatic%20rim%20lighting%2C%20sporty%20editorial%20photography%2C%20high%20contrast%2C%20warm%20tones%2C%20no%20text%2C%20clean%20background&width=800&height=800&seq=achb-cat-jersey-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20leather%20watch%2C%20minimalist%20bracelet%20and%20sunglasses%20on%20a%20travertine%20stone%20tray%2C%20warm%20neutral%20tones%2C%20sophisticated%20editorial%20still%20life%2C%20no%20text%2C%20elegant%20minimal%20composition&width=800&height=800&seq=achb-cat-accessories-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20leather%20tote%20bag%20on%20a%20warm%20terracotta%20floor%20tile%20with%20soft%20shadows%2C%20clean%20editorial%20product%20photography%2C%20minimal%20background%2C%20warm%20earthy%20tones%2C%20no%20text%2C%20refined%20composition&width=800&height=800&seq=achb-cat-bags-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Rich%20tan%20leather%20belt%20coiled%20on%20a%20weathered%20wooden%20cutting%20board%2C%20warm%20natural%20light%20from%20a%20window%2C%20rustic%20editorial%20photography%2C%20earthy%20tones%2C%20no%20text%2C%20clean%20simple%20composition&width=800&height=800&seq=achb-cat-belts-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Crystal%20perfume%20bottle%20with%20gold%20cap%20on%20a%20marble%20pedestal%20against%20a%20soft%20blush%20wall%2C%20luxury%20editorial%20product%20photography%2C%20elegant%20and%20refined%2C%20warm%20neutral%20tones%2C%20no%20text%2C%20minimal%20composition&width=800&height=800&seq=achb-cat-perfumes-v2&orientation=squarish&nocache=true',
  },
  {
    id: 'other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Artful%20flat-lay%20of%20assorted%20lifestyle%20items%20including%20a%20small%20notebook%2C%20keychain%2C%20phone%20case%20and%20sunglasses%20on%20a%20linen%20tablecloth%2C%20warm%20natural%20tones%2C%20editorial%20overhead%20shot%2C%20no%20text%2C%20clean%20organized%20aesthetic&width=800&height=800&seq=achb-cat-other-v2&orientation=squarish&nocache=true',
  },
];